var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [(_vm.screen == '2') ? _c('RVPPrintLavelNewv2', {
    attrs: {
      "propsParam": _vm.propsParameter
    }
  }) : (_vm.screen == '3') ? _c('RVPPrintLabelReviewv2', {
    attrs: {
      "propsParam": _vm.propsParameter
    }
  }) : (_vm.screen == '1') ? _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('legend', [_vm._v("Print Label")]), _vm._v(" "), _c('div', {
    staticClass: "stepper-wrapper"
  }, [_c('div', {
    staticClass: "stepper-container"
  }, [_c('div', {
    staticClass: "step active"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Print Sticker")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Inscan Flyer and AWB")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Review")])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.isManualEntryRestrict) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '0'),
      expression: "selected == '0'"
    }],
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4 text-center"
  }, [_vm._v("Print Sticker:")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-sm-4",
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "shippingID",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.shippingID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter/Scan AWB or Scan Flyer Code",
      "autocomplete": "off",
      "name": "shippingID",
      "id": "shippingID"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "drop": _vm.handleDragOver,
      "keydown": _vm.detectInputForStickerPrintv1,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }, _vm.handleInputForStickerPrintv1]
    }
  })])], 1), _vm._v(" "), _c('b-input-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4 text-right"
  }, [_vm._v("Print Sticker:")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-sm-4",
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipment),
      expression: "shipment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "shipment",
    class: {
      'form-control': true,
      'error': _vm.errors.has('form-1.shipment')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter/Scan AWB or Scan Flyer Code",
      "autocomplete": "off",
      "name": "shipment",
      "id": "shipment"
    },
    domProps: {
      "value": (_vm.shipment)
    },
    on: {
      "drop": _vm.handleDragOver,
      "keydown": _vm.detectInputForStickerPrintv1,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.shipment = $event.target.value
      }, _vm.handleInputForStickerPrintv1]
    }
  })])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submitRadioBtnCSS col-md-12 mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "input-group-text ml-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectPrinter),
      expression: "isSelectPrinter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "oldPrint",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isSelectPrinter, "0")
    },
    on: {
      "change": function($event) {
        _vm.isSelectPrinter = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FlyerBarcode"
    }
  }, [_vm._v(" Print ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected == '1'),
      expression: "selected == '1'"
    }],
    staticClass: "input-group-text ml-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSelectPrinter),
      expression: "isSelectPrinter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "newPrint",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isSelectPrinter, "1")
    },
    on: {
      "change": function($event) {
        _vm.isSelectPrinter = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "awb"
    }
  }, [_vm._v(" New Print ")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.submitform
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected != ''),
      expression: "selected != ''"
    }],
    staticClass: "btn btn-sm btn-danger ml-4",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading == true
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("Reset")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.validationerror))])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isRedirectLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isRedirectLoading = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.redirectionMsg))])], 1), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shipmentDetails.length > 1),
      expression: "shipmentDetails.length > 1"
    }],
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', {
    staticClass: "text-center tableheader"
  }, [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("Shipment ID")]), _vm._v(" "), _c('th', [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Last Modified Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "text-left"
  }, _vm._l((_vm.shipmentDetails), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AWBNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormat")(row.LastModifiedDate)))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.printDTOslip(row.AWBNumber)
        }
      }
    }, [_c('u', [_c('font', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("Print")])], 1)])])])
  }), 0)]), _vm._v(" "), _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)])])]), _vm._v(" "), (_vm.restrictTLQCModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "id": "restrictTLQCModal",
      "title": "Process QC Check",
      "z-index": "9999999999"
    },
    model: {
      value: (_vm.restrictTLQCModal),
      callback: function($$v) {
        _vm.restrictTLQCModal = $$v
      },
      expression: "restrictTLQCModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("TLQC Restrict")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelRestrict
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card qcCheckPanel"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("\n                                                " + _vm._s(_vm.restrictTLQCError))])]), _c('br')])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowReprintPopUp == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "id": "isShowReprintPopUp",
      "title": "Process QC Check"
    },
    model: {
      value: (_vm.isShowReprintPopUp),
      callback: function($$v) {
        _vm.isShowReprintPopUp = $$v
      },
      expression: "isShowReprintPopUp"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Reprint Sticker")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelReprint
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('h3', [_vm._v("Are you sure you want to reprint the sticker?")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("This action will be tracked and may require an explanation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('b-form-fieldset')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-6 pull-left"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.closeModelReprint
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.reprintRequest
    }
  }, [_vm._v("Yes,\n                                Reprint")])])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isShowReprintPopUpReprint == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "id": "isShowReprintPopUpReprint",
      "title": "Process QC Check"
    },
    model: {
      value: (_vm.isShowReprintPopUpReprint),
      callback: function($$v) {
        _vm.isShowReprintPopUpReprint = $$v
      },
      expression: "isShowReprintPopUpReprint"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alert: This is a reprint request for this shipment")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelReturnToPrintPage
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12 card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_c('h3', [_vm._v("You are not authorized to reprint the sticker for this shipment")])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('br')])])])])])])])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.showrequest) ? _c('RVPPrintLabelRequest') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('RVPPrintPendency')], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b99f2e6","hasScoped":true}!./src/views/components/RVPPrintLabelNewv2/RVPPrintLabelNewv2.component.html
// module id = 1569
// module chunks = 1